import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { AuthUiHelperService } from 'src/app/auth/auth.ui.helper.service';
import { LoginService } from 'src/app/auth/login/login.service';
import { NebulrAnonymousTranslationService } from 'src/app/shared/services/nebulr-anonymous-translation.service';

@Component({
  selector: 'nblocks-mfa-required',
  templateUrl: './mfa-required.page.html',
  styleUrls: ['./mfa-required.page.css']
})
export class MfaRequiredPage {

  error = false;
  loading = false;
  param = {};
  privacyPolicyUrl: string;
  
  constructor(
    private readonly loginService: LoginService,
    private readonly navCtrl: NavController,
    private readonly authUiHelperService: AuthUiHelperService,
    private readonly nebulrAnonymousTranslationService: NebulrAnonymousTranslationService, // Needed for translations to work properly
  ) {
    this.param = this.authUiHelperService.getYear();
    this.privacyPolicyUrl = this.authUiHelperService.getPrivacyPolicyUrl();
  }

  public async submit(form: NgForm): Promise<void> {
    try {
      this.loading = true;
      this.error = false;
      
      const { mfaCode } = form.value;
      await this.loginService.commitMfaCode(mfaCode);
      this.navCtrl.navigateRoot('auth/choose-user');
    } catch (error) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  public async handleKeyUp(e: KeyboardEvent, form: NgForm): Promise<void> {
    if (e.key === 'Enter' && form.valid) {
      this.submit(form);
    }
  }

}
